import { Button, Dialog } from 'ui';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import useDialogLoginStage from './useDialogLoginStage';

const DialogLoginStage = ({ open, onClick, onSuccess }) => {
  const { t, stages } = useDialogLoginStage({ onSuccess });

  return (
    <Dialog title={t('login:Selecciona una etapa para continuar')} size="m" isOpen={open} className={'dialog-login-stage'}>
      <div className="dialog-login-stage__list">
        {stages.map((stage) => (
          <Button
            key={stage.guid}
            size="sm"
            onClick={() => onClick(stage)}
            variant="primary-outline"
            text={stage.name}
            rightIcon="chevron-right"
          />
        ))}
      </div>
    </Dialog>
  );
};

DialogLoginStage.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
};

DialogLoginStage.defaultProps = {
  open: false,
  onClick: function () {},
};

export default DialogLoginStage;
